import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks";
import { UsersFilters } from "modules/Users/hooks/useUsersFilters";
import { UsersResponse } from "modules/Users/types";

const component = "Users";

export const UsersKeys = {
  filters: localQueryKey<UsersFilters>({ component, data: "filters" }),
  users: backendQueryKey<UsersResponse>({ component, baseUrl: ENV.systemBaseUrl, endpoint: "/users/search" })
};
